export const NOT_FOUND = 'not-found'
export const DASHBOARD = 'dashboard'

/* Account registration */
export const ACCOUNT_REGISTRATION_COMPLETE = 'account-registration-complete'
export const ACCOUNT_REGISTRATION_USHER = 'account-registration-usher'
export const ACCOUNT_REGISTRATION_ADD_MEMBERS =
  'account-registration-add-members'

/* User registration */
export const USER_REGISTRATION_COMPLETE = 'user-registration-complete'

/* All */
export const ALL = 'all'
export const ALL_TASKS = 'all-tasks'
export const ALL_CONVERSATIONS = 'all-conversations'

/* Google Drive */
export const GOOGLE_DRIVE_AUTH = 'googleDriveAuth'

/* Calendar */
export const CALENDAR = 'calendar'

/* People */
export const PEOPLE = 'people'
export const PEOPLE_CREATE = 'people-create'
export const PERSON_DETAIL = 'person-detail'

/* Guests */
export const GUESTS = 'guests'
export const GUESTS_CREATE = 'guests-create'
export const GUESTS_DETAIL = 'guests-detail'

/* Companies */
export const COMPANY_CREATE = 'company-create'
export const COMPANY_GUESTS_CREATE = 'company-guests-create'
export const COMPANY_DETAIL = 'company-detail'
export const COMPANY_GUESTS_DETAIL = 'company-guests-detail'
export const COMPANY_PEOPLE_CREATE = 'company-people-create'

/* Workflows */
export const WORKFLOW_DETAIL = 'workflow-detail'
export const WORKFLOW_HOME = 'workflow-home'

/* Mailboxes */
export const MAILBOX_NEW = 'mailbox-new'
export const MAILBOX_HOME = 'mailbox-home'
export const MAILBOX_KANBAN = 'mailbox-kanban'
export const MAILBOX_VERIFICATION_INTRO = 'mailbox-verification-intro'
export const MAILBOX_VERIFICATION_AUTO_FORWARDING =
  'mailbox-verification-auto-forwarding'
export const MAILBOX_VERIFICATION_AUTO_FORWARDING_TESTING =
  'mailbox-verification-auto-forwarding-testing'
export const MAILBOX_VERIFICATION_OUTGOING_EMAIL =
  'mailbox-verification-outgoing-email'
export const MAILBOX_SETTINGS_AUTO_FORWARDING =
  'mailbox-settings-auto-forwarding'
export const MAILBOX_SETTINGS_DIRECT_CONNECTION =
  'mailbox-settings-direct-connection'
export const MAILBOX_SETTINGS_ASSIGN_PEOPLE = 'mailbox-settings-assign-people'
export const MAILBOX_SETTINGS_GENERAL_SETTINGS =
  'mailbox-settings-general-settings'
export const MAILBOX_SETTINGS_CONVERSATION_RULES =
  'mailbox-settings-conversation-rules'
export const MAILBOX_SETTINGS_AUTO_RESPONDER = 'mailbox-settings-auto-responder'
export const MAILBOX_SETTINGS_OFFICE_HOURS = 'mailbox-settings-office-hours'
export const MAILBOX_SETTINGS_CHECKLIST_TEMPLATES =
  'mailbox-settings-checklist-templates'
export const MAILBOX_SETTINGS_CUSTOM_FIELDS = 'mailbox-settings-custom-fields'
export const MAILBOX_SETTINGS_SAVED_REPLIES = 'mailbox-settings-saved-replies'
export const MAILBOX_SETTINGS_OUTGOING_EMAIL = 'mailbox-settings-outgoing-email'
export const MAILBOX_SETTINGS_TICKET_PORTAL = 'mailbox-settings-ticket-portal'
export const MAILBOX_SETTINGS_EMAIL_SIGNATURE =
  'mailbox-settings-email-signature'
export const MAILBOX_SETTINGS_INTEGRATIONS = 'mailbox-settings-integrations'
export const MAILBOX_SETTINGS_MANAGE_WORKFLOW =
  'mailbox-settings-manage-workflow'
export const MAILBOX_SETTINGS_WORKFLOW_AUTOMATIONS =
  'mailbox-settings-workflow-automations'

/* Conversations */
export const CONVERSATION_NEW = 'conversation-new'
export const CONVERSATION_DETAIL = 'conversation-detail'

/* Projects */
export const PROJECT_NEW = 'project-new'

export const PROJECT_LISTING = 'project-listing'
export const PROJECT_KANBAN = 'project-kanban'
export const PROJECT_SCHEDULE = 'project-schedule'

export const PROJECT_SETTINGS_ASSIGN_PEOPLE = 'project-settings-assign-people'
export const PROJECT_SETTINGS_ASSIGN_GUESTS = 'project-settings-assign-guests'

export const PROJECT_SETTINGS_CHECKLIST_TEMPLATES =
  'project-settings-checklist-templates'
export const PROJECT_SETTINGS_CUSTOM_FIELDS = 'project-settings-custom-fields'
export const PROJECT_SETTINGS_DESCRIPTION_TEMPLATES =
  'project-settings-description-templates'
export const PROJECT_SETTINGS_EMAIL_SETTINGS = 'project-settings-email-settings'
export const PROJECT_SETTINGS_GENERAL_SETTINGS =
  'project-settings-general-settings'
export const PROJECT_SETTINGS_INTEGRATIONS = 'project-settings-integrations'
export const PROJECT_SETTINGS_MANAGE_WORKFLOW =
  'project-settings-manage-workflow'
export const PROJECT_SETTINGS_WORKFLOW_AUTOMATIONS =
  'project-settings-workflow-automations'

export const SAMPLE_PROJECT_LISTING = 'sample-projects-listing'
export const SAMPLE_PROJECT_KANBAN = 'sample-projects-kanban'

/* Tasks */
export const TASK_NEW = 'task-new'
export const SAMPLE_TASK_NEW = 'sample-task-new'
export const TASK_DETAIL = 'task-detail'
export const GLOBAL_TASK_NEW = 'global-task-new'

export const SAMPLE_TASK_DETAIL = 'sample-task-detail'

/* Developers */
export const DEVELOPERS_HOME = 'developers-home'
export const DEVELOPERS_OUTBOUND_WEBHOOKS = 'developers-outbound-webhooks'

/* Ticket Portal */
export const TICKET_PORTAL_LISTING = 'ticket-portal-listing'
export const TICKET_PORTAL_DETAIL = 'ticket-portal-detail'
export const TICKET_PORTAL_PROFILE = 'ticket-portal-profile'
